import React, { Component, Fragment } from 'react';
import { socketConnect } from 'socket.io-react';
import FacebookLogin from 'react-facebook-login';
import GoogleLogin from 'react-google-login';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';
import { userLogin } from 'store/user';
import Modal from 'components/Modal';
import InputValidation from 'components/InputValidation';
import PhoneInput from 'components/PhoneInput';
import { parsePhoneNumber } from 'react-phone-number-input';
import PureCheckBox from 'components/PureCheckBox';
import LogoImage from 'assets/megafit-images/mf-logo.svg';
import bannerSignin from 'assets/megafit-images/sign-banner.png';
import LogoImageIcon from 'assets/megafit-images/mf-logo.svg';
import DietPlanIcon from 'assets/megafit-images/diat-plan.gif';
import MasterIcon from 'assets/mastercard.svg';
import VisaIcon from 'assets/visa.svg';
class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      errors: {},
      username: '', 
      first_name:'',
      last_name:'',
      password: '',
      sameaswhatsapp:1,
      phone:'',
      whatsUpnumber:'',
      WPC_CODE:'',
      PC_CODE:'',
      referer: '',
      showPassword: false,
      errorModalMessage: '',
      close: () => this.setState({ errorModalMessage: '' }),
      xyz: false,
      activeStep:1
    };
  }

  socketRegistration = action => {
    if (this.SignUpRef) {
      if (action.type === 'setOk') {
        const { location } = this.props;
        const { redirect } = location.query;
        this.props.login(action.data);
        if(redirect){
          browserHistory.push('/'+redirect);
        }else{
        browserHistory.push('/');
        }
      } else if (action.type === 'setErr') {
        // let activeState = ()
        // Object.keys(action.data).map()
        const filteredArray = (Object.keys(action.data)).filter(value => ['first_name','last_name','phone','whatsUpnumber'].includes(value));
        const activeStep = (filteredArray.length>0)?1:2;
        this.setState({ errors: action.data,activeStep });
      } else if (['facebookErr', 'googleErr'].indexOf(action.type) > -1) {
        this.setState({ errorModalMessage: action.message });
      } else if (action.type === 'checkRefOk') {
        this.setState({ referer: action.data.refId });
      } else if (action.type === 'checkRefErr') {
        this.setState({
          errorModalMessage: action.message,
          close: () => {
            this.setState({ errorModalMessage: '' });
            browserHistory.push('/sign-up');
          }
        });
      }
    }
  };

  componentWillMount() {
    this.props.socket.on('registration', this.socketRegistration);
    const { params } = this.props;
    if ('token' in params && params.token) {
      this.props.socket.emit('registration', { type: 'checkRef', data: { token: this.props.params.token } });
    }
  }

  componentWillUnmount() {
    this.props.socket.removeListener('registration', this.socketRegistration);
  }

  componentDidMount() {
    setTimeout(() => this.setState({ xyz: true }), 10);
  }

  handleOptionChange = (name, value) => {
    this.setState({ [name]: value });
  };
  
  submit(e, browserId,activeStep) {
    e.preventDefault();
    const { email, password, referer, first_name, last_name} = this.state;
    let phone =this.state.phone;
    let whatsUpnumber =this.state.whatsUpnumber;
    let phoneCode ='';
    let whatCode ='';
    if(whatsUpnumber!='' && whatsUpnumber!=null){
      let phcode = parsePhoneNumber(whatsUpnumber);
      console.log(phcode);
      whatCode= (phcode)?'+'+phcode.countryCallingCode:null;
      whatsUpnumber=phcode.nationalNumber;
    }
    if(phone!='' && phone!=null ){
      let phcode =parsePhoneNumber(phone);
      //console.log(phcode);
      phoneCode= (phcode)?'+'+phcode.countryCallingCode:null;
      phone=phcode.nationalNumber;
    }
    this.props.socket.emit('registration', { type: 'set', data: { email, first_name:first_name,last_name:last_name, password, referer, PC_CODE:phoneCode, WPC_CODE:whatCode, phone, whatsUpnumber, browserId } });
  }

  submitFacebook(response, browserId) {
    if ('id' in response) {
      response.type = this.state.type;
      response.language = this.props.language;
      this.props.socket.emit('registration', { type: 'facebook', data: { ...response, browserId } });
    }
  }

  submitGoogle(response, browserId) {
    response.type = this.state.type;
    response.language = this.props.language;
    this.props.socket.emit('registration', { type: 'google', data: { ...response, browserId } });
  }

  render() {
    const { errors, errorModalMessage, email, password, xyz, close , first_name, last_name, whatsUpnumber, phone, PC_CODE, WPC_CODE, sameaswhatsapp, activeStep} = this.state;
    const onChange = (name, value) => this.setState({ [name]: value });
    const onWhatChange = (name, value) =>{
      this.setState({ [name]: value });
      if(sameaswhatsapp){
        this.setState({ 'phone': value });
      }
    };
  
    console.debug(WPC_CODE);
    const { settings, browserId, location } = this.props;
    const { redirect } = location.query;
    let redirectParam='';
    if(redirect!=undefined){
      redirectParam='?redirect='+redirect;
    }
    const facebookAppId = settings.getValue('FACEBOOK_APP_ID');
    const googleAppId = settings.getValue('GOOGLE_APP_ID');
    // console.log(errors)
    return (
      <div ref={el => (this.SignUpRef = el)} className={`mf-container register-page`}>
      <div className='full-width'>   
        <div className='sign-container'>
        <div className='sign-left'>
        <Link to='/checkout' ><img src={bannerSignin} alt='Megafit-Banner' /></Link>
        {/* <img src={bannerSignin} alt='Megafit-Banner' />
          <div className='sign-left-inner '>
            <div class="flex-container">
              <div class="sign-content-left">
                <h1> 
                  <span class="mainSpan"><span class="small-txt">Customize</span><span class="normal-txt"> Your Fuel,</span></span>
                  <span class="mainSpan"><span class="small-txt">Maximize</span><span class="normal-txt"> Your Gains</span></span>
                </h1>
              </div>
              <div class="sign-content-right">
                <p>Make you own Macro <br/>Counted Meals with</p>
                <span class="yellow-box"><strong>MegaFit</strong> CustomFit<sup>®</sup></span>
              </div>    
            </div>            
          </div>         */}
        </div>
        <div className={`sign-right`}>
        <div class="sigin-holder">
          <div class="logo-holder">
            <div className='logo'>  <Link to='/' onClick={() => stop()} onlyActiveOnIndex><img src={LogoImage} alt='Megafit' /></Link></div>
            <div className='logo-icon'>  <Link to='/' onClick={() => stop()} onlyActiveOnIndex><img src={LogoImageIcon} alt='Megafit' /></Link></div>
          </div>
          <div class="form-holder">
          <div class="marquee">
          <img src={DietPlanIcon} alt='megaFit' />
          <div class="diet-text">
            <p>Plan your menu and choose your meals completely free before starting.</p><p>Sign in to start, select your macros and see the dish options.</p> 
          </div>        
        </div>  
        <div className='sign-up-form signupform'>
        <div className='sign-in-top mt-1'>
           <Link to='/sign-in' className='colorTitle'>Sign In</Link>
          <span className='colorTitle ml-3'>Sign Up</span>
          </div>
          <form className='form'>
          
          {activeStep == 1 &&<Fragment>
            <div className='sign-form-container'>
              <div className='sign-up-row mt-5 sign-name'>
                  <div className='sign-up-input'>
                  <label class="textLeft">First Name</label>
                      <InputValidation
                        value={first_name}
                        name='first_name'
                        onChange={onChange}
                        errors={errors}
                        placeholder='First Name'
                        inputSelfClassName='standart-input b-rounded-blue'
                      />
                    </div>
                    <div className='sign-up-input'>
                    <label class="textLeft">Last Name</label>
                      <InputValidation
                        value={last_name}
                        name='last_name'
                        onChange={onChange}
                        errors={errors}
                        placeholder='Last Name'
                        inputSelfClassName='standart-input b-rounded-blue'
                      />
                    </div>
            </div>
            <div className='sign-up-input mt-4'>
              <label className='textLeft'>WhatsApp Number</label>
              <PhoneInput
                classError='has-error letter-xs'
                errors={errors}
                labelText={'WhatsApp Number'}
                phoneProps={{ 
                  value:(WPC_CODE!=null && WPC_CODE!=undefined && whatsUpnumber!=undefined)?WPC_CODE+(whatsUpnumber.replace(WPC_CODE,'')):whatsUpnumber,
                    defaultCountry:"AE",
                    international:true,
                    name:'whatsUpnumber',
                    placeholder:'WhatsApp Number',
                    countryCallingCodeEditable:false,
                    className:'standart-input b-rounded-blue',
                    onChange:(value) => onWhatChange('whatsUpnumber', value)
                }}
              />
            </div>
            <div className='search-title login-text mt-3 color-transparent'>
            <p className='line-height-xsnormal login-text mb-0 color-transparent'>
              By signing in or signing up, I agree to <strong>MegaFit</strong>&nbsp;
              <Link to='/terms' >Terms & Conditions</Link>, <Link to='/refunds' >Refund & Cancellation policy</Link>, <Link to='/privacy-policy' >Privacy Policy</Link>,
              I confirm that I am 18 years of age or older, and consent to receiving email communication.
            </p>
            </div>
            <div className='sign-up-input mt-3'>
              <div className='checkbox-con'>
              <PureCheckBox value={sameaswhatsapp} id="sameaswhatsapp" name="sameaswhatsapp" onChange={(name,checked,val)=>{
                this.setState({sameaswhatsapp:checked});
                if(checked){
                  this.setState({phone:whatsUpnumber});
                }
              }} />
              <div className='checkbox-label-con'>
                 <label className='checkbox-label' for="sameaswhatsapp">Same number for WhatsApp</label>
              <span className='checkbox-sublabel'>All communication will be through WhatsApp</span>
              </div>
              </div>
              </div>
              {!sameaswhatsapp && <div className='sign-up-input mt-4 additional-number'>
              <label className='textLeft'>Calling Number</label>

              <PhoneInput
              errors={errors}
              labelText={'Calling Number'}
              classError='has-error letter-xs'
                 phoneProps={{ 
                      value:(PC_CODE!=null && PC_CODE!=undefined && phone!=undefined)?PC_CODE+(phone.replace(PC_CODE,'')):phone,
                      defaultCountry:"AE",
                      className:'standart-input b-rounded-blue',
                      // labels:{'phone':'Calling Number'},
                      name:'phone',
                      international:true,
                      placeholder:'Calling Number',
                      countryCallingCodeEditable:false,
                      onChange:(value) => onChange('phone', value)
                }}
              />
            </div>}
            </div>
            <div className='sign-up-input mt-4 sign-up-button d-flex align-items-center justify-content-around c-mt-30'>
              <input onClick={e => this.submit(e, browserId,activeStep)} type='submit' value='Continue' className='form-button letter-sm w-100' />
            </div></Fragment>}
            {activeStep == 2 && <Fragment><div className='sign-form-container'><div className='sign-up-input mt-4'>
            <label class="textLeft">Email address</label>
              <InputValidation
                value={email}
                name='email'
                onChange={onChange}
                errors={errors}
                placeholder='Enter your email address'
                inputSelfClassName='standart-input b-rounded-blue'
              />
            </div>
            <div className='sign-up-input mt-4'>
            <label class="textLeft">Password</label>
              <InputValidation
                type='password'
                value={password}
                name='password'
                onChange={onChange}
                errors={errors}
                placeholder='Enter your password'
                inputSelfClassName='standart-input b-rounded-blue'
              />
            </div>
            <div className='search-title login-text mt-3'>
            <p className='line-height-xsnormal login-text mb-0'>
              {' By signing in or signing up, I agree to MegaFit'}
              <Link to='terms' className='letter-xs'>{'Terms & Conditions'}</Link>, <Link to='/refunds' className='letter-xs'>{'Refund & Cancellation policy'}</Link>{' and '}
              <Link to='/privacy-policy' className='letter-xs'>{'Privacy Policy'}</Link>{',\n' +
            'I confirm that I am 18 years of age or older, and consent to receiving email communication.'}
            </p>
            </div></div>
            <div className='sign-up-input mt-4 sign-up-button d-flex align-items-center justify-content-around'>
              <input onClick={e => this.submit(e, browserId,activeStep)} type='submit' value='Create Account' className='form-button letter-sm w-100' />
            </div><div className='mt-4 mr-1 text-center'>
            <span className='login-text' ><a href='javascript:void(0)' onClick={e=> this.setState({activeStep:1})}>Back</a></span>
          </div></Fragment>}
          </form>
          {/* <div className='search-title login-text mt-3'>
            <span className='colorTitle letter-sm'>Or</span>
          </div>
          {googleAppId && <GoogleLogin
            clientId={googleAppId}
            onSuccess={response => this.submitGoogle(response, browserId)}
            buttonText='Sign up with Google'
            className='sign-up-input mt-3 sign-up-button-google d-flex align-items-center justify-content-around'
            onFailure={data => console.log(data)}
          />}
          {facebookAppId && <FacebookLogin
            appId={facebookAppId}
            autoLoad={false}
            size='small'
            callback={response => this.submitFacebook(response, browserId)}
            fields='name,email,picture,first_name,last_name'
            textButton='Sign up with Facebook'
            cssClass='sign-up-input mt-3 mb-2 sign-up-button-facebook d-flex align-items-center justify-content-around'
          />} */}
         
          <div className='mt-4 mr-1 text-center sign-up-bottom'>
            <span className='mt-1 mr-1 grey-text'>Already have an Account? </span>
          <span className='login-text'><Link to={`/sign-in${redirectParam}`}>Sign In</Link></span>
          </div>
          {/* {redirectParam=='' && <div className='mt-4 mr-1 text-center sign-up-bottom'>
          <span className='login-text'><Link to='/checkout'>Build your menu</Link></span></div>} */}
          <div className='footer_bottom_copyrights'>
              <ul className="inline-list payment-icons footer__section">
                <li className="icon--payment master"><img src={MasterIcon} alt='Mastercard' /></li>
                <li className="icon--payment master"><img src={VisaIcon} alt='Visa' /></li>
              </ul>
              <ul class="footer-block__details-content list-unstyled">
                  <li><p class="footer_links_head font-weight-semibold">Help &amp; Info:</p></li>
                  <li><a href="https://megafit.ae/pages/delivery-policy" class="link link--text list-menu__item list-menu__item--link" target='_blank'>
                    Delivery Policy
                  </a></li>
                  <li><a href="https://megafit.ae/pages/privacy-policy" class="link link--text list-menu__item list-menu__item--link" target='_blank'>
                    Privacy Policy
                  </a></li>
                  <li><a href="https://megafit.ae/pages/refund-cancellation-policy" class="link link--text list-menu__item list-menu__item--link" target='_blank'>
                    Refund &amp; Cancellation Policy
                  </a></li>
                  <li><a href="https://megafit.ae/pages/terms-and-conditions" class="link link--text list-menu__item list-menu__item--link" target='_blank'>
                    Terms &amp; Conditions
                  </a></li>
                </ul>
            </div>
        </div>
        {errorModalMessage &&
          <Modal
            close={close}
            message={errorModalMessage}
          />
        }
          </div>
        </div>        
        
      </div>
      </div>
      </div>
      </div>   
    );
  }
}

SignUp.propTypes = {
  socket: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
  browserId: PropTypes.string.isRequired,
  params: PropTypes.any.isRequired,
  login: PropTypes.func.isRequired,
  settings: PropTypes.object
};

const props = state => ({
  language: state.user.language,
  browserId: state.user.browserId,
  settings: state.settings
});

function actions(dispatch) {
  return {
    login: user => dispatch(userLogin(user))
  };
}

export default socketConnect(connect(props, actions)(SignUp));
